import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-define',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  templateUrl: './define.component.html',
  styleUrl: './define.component.scss'
})
export class DefineComponent {
}
